import { Component, ElementRef, output, viewChild } from '@angular/core';
import { ButtonComponent } from '../../../../../../../../shared/components/button/button.component';

interface SelectedImage {
  file: File;
  preview: string;
}

export interface ProcessedImage {
  success: boolean;
  image?: SelectedImage;
  error?: string;
}

@Component({
  selector: 'smart-fix-image-attach-component',
  templateUrl: './smart-fix-image-attach-component.component.html',
  styleUrls: ['./smart-fix-image-attach-component.component.scss'],
  imports: [ButtonComponent],
})
export class SmartFixImageAttachComponent {
  selectedImages: SelectedImage[] = [];
  maxImages: number = 1;
  maxFileSize: number = 5 * 1024 * 1024; // 5MB
  isLoading = false;
  imageAttached = output<ProcessedImage>();
  fileInput = viewChild<ElementRef<HTMLInputElement>>('fileInput');

  attachImage(event: Event) {
    const input = event.target as HTMLInputElement;

    if (input.files) {
      const files = Array.from(input.files);
      this.selectedImages = [];
      let processedFiles = 0;
      const totalFiles = Math.min(files.length, this.maxImages);

      if (totalFiles === 0) {
        return;
      }

      for (const file of files) {
        if (this.selectedImages.length >= this.maxImages) {
          break;
        }

        if (!file.type.startsWith('image/')) {
          this.imageAttached.emit({ success: false, error: 'incorrect_format' });

          processedFiles++;
          if (processedFiles === totalFiles) {
            this.checkAndContinue();
          }
          continue;
        }

        if (file.size > this.maxFileSize) {
          this.imageAttached.emit({ success: false, error: 'too_large' });

          processedFiles++;
          if (processedFiles === totalFiles) {
            this.checkAndContinue();
          }
          continue;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          const preview = e.target?.result as string;
          this.selectedImages.push({
            file,
            preview,
          });

          processedFiles++;
          console.log(
            `Processed ${processedFiles}/${totalFiles} files, selectedImages length: ${this.selectedImages.length}`
          );

          if (processedFiles === totalFiles) {
            this.checkAndContinue();
          }
        };

        reader.readAsDataURL(file);
      }

      input.value = '';
    }
  }

  checkAndContinue(): void {
    if (this.selectedImages.length > 0) {
      this.imageAttached.emit({
        success: true,
        image: { file: this.selectedImages[0].file, preview: this.selectedImages[0].preview },
      });
    } else {
      this.isLoading = false;
    }
  }

  openFilePicker() {
    this.fileInput()?.nativeElement?.click();
  }

  triggerFileInput() {
    this.fileInput()?.nativeElement.click();
  }

  triggerCameraInput() {
    const cameraInput = document.querySelector('#cameraInput') as HTMLInputElement;
    cameraInput?.click();
  }

  handleKeydown(event: KeyboardEvent, type: 'file' | 'camera') {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      if (type === 'file') {
        this.triggerFileInput();
      } else {
        this.triggerCameraInput();
      }
    }
  }
}
